import { ChangeDetectorRef, Injectable, TemplateRef, Type } from '@angular/core';
import { deviceService } from '../services-hardware/deviceService';
import { AlertService } from '../services/alert.service';
import { tools } from '../services/tools';
import * as lodhash from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';
import { LogService } from '../services/log-service.service';
import { Table } from 'primeng/table';

@Injectable({
  providedIn: 'root',
})
export class PrimeNgArrayD4Service {
  constructor(
    private alertService: AlertService,
    private deviceService: deviceService,
    private tools: tools,
    private sanitizer: DomSanitizer,
  ) {}

  //input : time (with string like min,hour,....)
  //output : time in seconds
  public inputTimeAsStringConverter(duration: any): number {
    if (duration.includes(',')) duration = duration.replace(',', '.');
    let durationFloat: number = duration.match(/[0-9\.\,]+/g).map(Number)[0];
    if (durationFloat == Number.NaN) {
      this.alertService.error('format saisi incorrect', 1600);
      return 0;
    }
    let durationUnit: string = duration
      .match(/[^0-9\.\,]+/g)
      .map(String)[0]
      .toLowerCase()
      .replace(/\s/g, '');

    let newDurationUnit: string = 'hour';
    let newDurationValue: number = 1;
    if (durationFloat != undefined) newDurationValue = durationFloat;

    if (durationUnit.includes('hour') || durationUnit.includes('heure') || durationUnit == 'h') {
      newDurationUnit = 'hour';
      newDurationValue = newDurationValue * 3600;
    }
    if (durationUnit.includes('min') || durationUnit.includes('minute') || durationUnit == 'm') {
      newDurationUnit = 'minute';
      newDurationValue = newDurationValue * 60;
    }
    if (durationUnit.includes('day') || durationUnit.includes('jour') || durationUnit == 'j' || durationUnit == 'd') {
      newDurationUnit = 'day';
      newDurationValue = newDurationValue * 86400;
    }
    return newDurationValue;
  }

  //input time in secondes
  public timeToHumanReadable(time: number): string {
    if (time == undefined || time == null || time == 0) return '0';
    function numberEnding(number: number) {
      return number > 1 ? 's' : '';
    }

    let years = Math.floor(time / 31536000);
    if (years) {
      return (time / 31536000).toFixed(2) + ' année' + numberEnding(years);
    }
    let days = Math.floor((time %= 31536000) / 86400);
    if (days) {
      return ((time %= 31536000) / 86400).toFixed(2) + ' jour' + numberEnding(days);
    }
    let hours = Math.floor((time %= 86400) / 3600);
    if (hours) {
      return ((time %= 86400) / 3600).toFixed(2) + ' heure' + numberEnding(hours);
    }
    let minutes = Math.floor((time %= 3600) / 60);
    if (minutes) {
      return ((time %= 3600) / 60).toFixed(2) + ' minute' + numberEnding(minutes);
    }
    let seconds = time % 60;
    if (seconds) {
      return seconds + ' seconde' + numberEnding(seconds);
    }
    return '0';
  }

  /**
   * Input : array définition, array indice in page if more than one
   */
  public getLocalUserWidthDefinition(columnsDefinition: columnDefinition[], arrayName: string): columnDefinition[] {
    if (arrayName == undefined) return columnsDefinition;
    let definitionsReturn: columnDefinition[] = [];
    let arraySettings = this.deviceService.decryptDataLocalStorage(arrayName + '-array');
    if (arraySettings != null) {
      if (Array.isArray(arraySettings) && arraySettings.length > 0 && arraySettings.length == columnsDefinition.length) {
        arraySettings.forEach((localColumnDefinition) => {
          let matchingDefinition: any = columnsDefinition.find((columnDefinition) => {
            return columnDefinition.name == localColumnDefinition.name;
          });
          if (matchingDefinition?.name != '') {
            if (matchingDefinition.ngStyle == '') matchingDefinition.ngStyle = {};
            matchingDefinition.ngStyle['flex.px'] = localColumnDefinition.value;
            definitionsReturn.push(matchingDefinition);
          } else {
            definitionsReturn.push(localColumnDefinition);
          }
        });
      } else if (Array.isArray(arraySettings) && arraySettings.length > 0 && arraySettings.length != columnsDefinition.length) {
        //new column definition => remove setting
        this.removeLocalUserDefinition(arrayName);
        return columnsDefinition;
      }
    } else definitionsReturn = columnsDefinition;
    return definitionsReturn;
  }

  public setLocalUserWidthDefinition(columnsDefinition: columnDefinition[], arrayName: string) {
    if (arrayName == undefined) return;
    let userDefinition: any[] = [];
    columnsDefinition.forEach((columnDefinition) => {
      if (columnDefinition.name != '') {
        let def = {
          name: columnDefinition.name,
          value: columnDefinition.ngStyle['flex.px'],
        };
        userDefinition.push(def);
      }
    });
    this.deviceService.encrypteDataLocalStorage(arrayName + '-array', JSON.stringify(userDefinition), false);
  }

  public removeLocalUserDefinition(arrayName: string) {
    if (arrayName == undefined) return;
    this.deviceService.clearItemLocalStorage(arrayName + '-array', false);
  }

  //check if column objectName is identical to columnDefinition property
  public colsContainUnallowKeyWord(columnDefinition: columnDefinition[]): boolean {
    if (columnDefinition.length == 0) return false;
    let containUnallowValue: boolean = false;
    let unallowList: string[] = ['readOnly'];

    columnDefinition.forEach((col) => {
      if (unallowList.includes(col.name)) {
        containUnallowValue = true;
      }
    });
    return containUnallowValue;
  }

  public convertDateTimeToDateInObject(columnDefinition: columnDefinition[], object: any): any {
    let objectReturn = JSON.parse(JSON.stringify(object));
    Object.keys(object).forEach((key) => {
      let matchingColumn = columnDefinition.find((col) => {
        return col.name == key;
      });
      if (matchingColumn?.type == 'date') objectReturn[key] = this.tools.getIsoDate(object[key]);
    });
    return objectReturn;
  }

  public getImgB64(colName: string, object: any): any {
    let valSanitize: any;
    let value: string;
    if (colName.includes('.')) value = lodhash.get(object, colName);
    else value = object[colName];
    if (value == undefined) {
      value = '';
      valSanitize = '';
    } else {
      if (value.includes('data:image'))
        valSanitize = this.sanitizer.bypassSecurityTrustResourceUrl(value); //default consider svg picture
      else valSanitize = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/svg+xml;base64,' + value);
    }
    return valSanitize;
  }

  public resetLocalConfiguration(
    columnsDefinitionRef: columnDefinition[],
    columnsDefinition: columnDefinition[],
    changeDetectorRef: ChangeDetectorRef,
    arrayName: string,
    table: Table | undefined,
  ) {
    for (let i = 0; i < columnsDefinitionRef.length; i++) {
      if (columnsDefinitionRef[i].name != columnsDefinition[i].name) {
        //=> not in same plave
        //find index in columnDef
        let indexInDef = columnsDefinition.findIndex((columnDefinition) => {
          return columnDefinition.name == columnsDefinitionRef[i].name;
        });
        columnsDefinition.splice(i, 0, columnsDefinition.splice(indexInDef, 1)[0]);
      }
    }
    //setting ngStyle
    columnsDefinition.forEach((columnDefinition: columnDefinition) => {
      let fullDefRef: any = columnsDefinitionRef.find((columnDefinitionRef) => {
        return columnDefinitionRef.name == columnDefinition.name;
      });
      columnDefinition.ngStyle = JSON.parse(JSON.stringify(fullDefRef.ngStyle));
    });
    if (table) {
      table.destroyStyleElement();
      table.cd.detectChanges();
    } else {
      LogService.logContext(this);
    }
    changeDetectorRef.detectChanges();
    this.removeLocalUserDefinition(arrayName);
  }
}

export interface columnDefinition {
  type:
    | 'checkBox'
    | 'string'
    | 'textArea'
    | 'number'
    | 'phone'
    | 'currency'
    | 'date'
    | 'enum'
    | 'decimal'
    | 'edit'
    | 'dateTime'
    | 'icon'
    | 'imgB64'
    | 'booleanCheckBox'
    | 'duration'
    | 'booleanDropDown'
    | 'link'
    | 'geolocalisation'
    | 'mail'
    | 'summary'
    | '';
  readOnly: boolean;
  name: string;
  displayName: string;
  ngStyle: any; //see https://angular.io/api/common/NgStyle
  enum: { value: any; displayValue: string }[] | null;
  drop: {
    dropName: string;
    dropType: string;
    itemsToSet?: { origin: string; destination: string }[];
  } | null;
  localFilter: boolean | null;
  help?: string;
  copyBtn?: boolean;
  helpValue?: boolean;
  printLine?: lineDisplay;
  writeLine?: writeMethod;
  popUpComponent?: popUpComponent;
  datas?: any;
}

export interface lineDisplay {
  methodImplementation: (...args: any[]) => twoLinesDisplay;
}

export interface writeMethod {
  methodImplementation: (field: string, object: any, event: any) => any;
}

export interface popUpComponent {
  component: string | TemplateRef<any> | Type<any>;
  data: any;
  styleDefinition?: any;
}

export interface twoLinesDisplay {
  topLine: string;
  bottomLine: string;
}
